module.exports = __webpack_public_path__ + "static/img/monitor_item_image1.4f6d03f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/programme/monitor_item_image1.png
// module id = ebY3
// module chunks = 1